<template>
  <div class="sidebar-pinned">
    <Navbar />
    <main class="admin-main">

      <!-- ── Page Header ── -->
      <div class="page-header">
        <div class="container">
          <div class="d-flex align-items-center text-white" style="padding: 32px 0;">
            <div class="header-icon-wrap mr-3">
              <i class="fe fe-settings" style="font-size: 22px;"></i>
            </div>
            <div>
              <h4 class="mb-0 font-weight-bold">Edit Facility Details</h4>
              <small style="opacity: 0.8;">Update facility information</small>
            </div>
          </div>
        </div>
      </div>

      <div class="container mt-n3 pb-5">

        <!-- ── Contact Information ── -->
        <div class="card shadow-sm form-card mb-4">
          <div class="form-card-header">
            <div class="section-number">1</div>
            <h6 class="mb-0 font-weight-bold text-white">Contact Information</h6>
          </div>
          <div class="card-body px-4 pt-4 pb-3">
            <div class="form-row">
              <div class="form-group col-md-6">
                <label class="small font-weight-bold text-secondary">Contact Surname</label>
                <input type="text" v-model="auth_user.lastname" class="form-control" placeholder="Last Name" />
              </div>
              <div class="form-group col-md-6">
                <label class="small font-weight-bold text-secondary">Contact First Name</label>
                <input type="text" v-model="auth_user.firstname" class="form-control" placeholder="First Name" />
              </div>
              <div class="form-group col-md-6">
                <label class="small font-weight-bold text-secondary">Contact Middle Name</label>
                <input type="text" v-model="auth_user.middlename" class="form-control"
                  placeholder="Middle Name" />
              </div>
              <div class="form-group col-md-6">
                <label class="small font-weight-bold text-secondary">Contact Email</label>
                <input type="email" class="form-control" placeholder="Email"
                  v-model="auth_user.email" />
              </div>
              <div class="form-group col-md-6">
                <label class="small font-weight-bold text-secondary">Contact Phone Number</label>
                <input v-phone type="text" class="form-control" placeholder="Phone Number"
                  v-model="auth_user.phone_number" />
              </div>
            </div>
          </div>
        </div>

        <!-- ── Facility Details ── -->
        <div class="card shadow-sm form-card mb-4">
          <div class="form-card-header">
            <div class="section-number">2</div>
            <h6 class="mb-0 font-weight-bold text-white">Facility Details</h6>
          </div>
          <div class="card-body px-4 pt-4 pb-3">
            <div class="form-row">
              <div class="form-group col-md-6">
                <label class="small font-weight-bold text-secondary">Provider Code</label>
                <input type="text" class="form-control" placeholder="Provider Code"
                  v-model="auth_user.facility_code" />
              </div>

              <div class="form-group col-md-6">
                <label class="small font-weight-bold text-secondary">LGA</label>
                <select class="form-control" v-model="auth_user.localgovt" @change="fetchWards">
                  <option v-for="lga in lga_states" v-bind:key="lga.id" :value="lga.id">
                    {{ lga.local_name }}
                  </option>
                </select>
              </div>

              <div class="form-group col-md-6">
                <label class="small font-weight-bold text-secondary">Ward</label>
                <select class="form-control" v-model="auth_user.ward" @change="fetchCommunities">
                  <option v-for="ward in wards" :key="ward.id" :value="ward.id">{{ ward.ward_name }}</option>
                </select>
              </div>

              <div class="form-group col-md-6">
                <label class="small font-weight-bold text-secondary">Community </label>
                <select class="form-control" v-model="auth_user.community">
                  <option value="">{{ communities.length ? '-- Select Community --' : '-- Select a ward first --' }}</option>
                  <option v-for="c in communities" :key="c.id" :value="c.id">{{ c.name }}</option>
                </select>
              </div>
              <div class="form-group col-md-6">
                <label class="small font-weight-bold text-secondary">Facility Name</label>
                <input type="text" class="form-control" placeholder="Company Name"
                  v-model="auth_user.agency_name" />
              </div>
              <div class="form-group col-md-6">
                <label class="small font-weight-bold text-secondary">Facility Type</label>
                <select class="form-control" v-model="auth_user.phc_general">
                  <option>Public</option>
                  <option>Private</option>
                </select>
              </div>

              <div class="form-group col-md-6">
                <label class="small font-weight-bold text-secondary">Care Level</label>
                <select class="form-control" v-model="auth_user.phc_type">
                  <option value="">All</option>
                  <option>Primary</option>
                  <option>Secondary</option>
                  <option>Tertiary</option>
                </select>
              </div>

              <div class="form-group col-md-6">
                <label class="small font-weight-bold text-secondary">Address</label>
                <input type="text" class="form-control" placeholder="123 Street" v-model="auth_user.address1" />
              </div>
            </div>
          </div>
        </div>

        <!-- ── Submit ── -->
        <div class="card shadow-sm border-0 form-card">
          <div class="card-body px-4 py-3 d-flex justify-content-end">
            <button type="submit" class="btn btn-submit px-5" @click="editUser">
              <i class="fe fe-save mr-2"></i> Save changes
            </button>
          </div>
        </div>
      </div>

      <div class="vld-parent">
        <loading :active.sync="isLoading" loader="dots" :can-cancel="true" :is-full-page="fullPage"></loading>
      </div>
    </main>
  </div>
</template>
<script>
  // @ is an alias to /src
  // import Settings from '@/components/Settings.vue'
  import Navbar from "@/views/Navbar.vue";
  import Loading from "vue-loading-overlay";
  export default {
    // name: 'Home',
    components: {
      Navbar,
      Loading,
    },
    data() {
      return {
        auth_user: "",
        providers: "",
        user: null,
        image: "",
        sector: "",
        lga_states: "",
        wards: [],
        communities: [],
        isLoading: false,
        fullPage: true,
      };
    },
    beforeMount() {
      this.axios
        .get(`/api/v1/auth/user/zam/${this.$route.params.id}`)
        .then((response) => {
          this.auth_user = response.data.user;

          const lgId = response.data.local_government
            ? response.data.local_government.id
            : Number(this.auth_user.localgovt) || null;
          const wardId = response.data.ward
            ? response.data.ward.id
            : Number(this.auth_user.ward) || null;
          const communityId = response.data.community
            ? response.data.community.id
            : Number(this.auth_user.community) || null;

          if (lgId) this.auth_user.localgovt = lgId;
          if (wardId) this.auth_user.ward = wardId;

          if (lgId) {
            this.axios.get(`/api/v1/auth/getwards/${lgId}`)
              .then(r => { this.wards = r.data.data; })
              .catch(console.error);
          }

          if (wardId) {
            this.axios.get(`/api/v1/auth/communities`, { params: { ward_id: wardId } })
              .then(r => {
                this.communities = r.data || [];
                if (communityId) this.auth_user.community = communityId;
              })
              .catch(console.error);
          }
        })
        .catch((error) => {
          console.error(error);
        });
    },
    methods: {
      getProviders() {
        this.user = JSON.parse(localStorage.getItem("user"));

        this.axios
          .get(`/api/v1/auth/providerAgency/95933`)
          .then((response) => {
            this.providers = response.data.data;
            console.log(response);
          })
          .catch((error) => {
            console.error(error);
          });
      },
      getUser() {
        this.axios
          .get(`/api/v1/auth/user/zam/${this.$route.params.id}`)
          .then((response) => {
            this.auth_user = response.data.user;
            console.log(response);
          })
          .catch((error) => {
            console.error(error);
          });
      },

      fetchLga() {
        this.axios
          .get(`/api/v1/auth/lga/2679`)
          .then((response) => {
            this.lga_states = response.data.data;
            console.log(response);
          })
          .catch((error) => {
            console.error(error);
          });
      },

      fetchWards() {
        this.auth_user.ward = "";
        this.auth_user.community = "";
        this.communities = [];
        this.axios
          .get(`/api/v1/auth/getwards/${this.auth_user.localgovt}`)
          .then((response) => {
            this.wards = response.data.data;
          })
          .catch((error) => {
            console.error(error);
          });
      },

      fetchCommunities() {
        // this.auth_user.community = "";
        // this.communities = [];
        if (!this.auth_user.ward) return;
        this.axios
          .get(`/api/v1/auth/communities`,{
            params: {
              ward_id: this.auth_user.ward
            }
          })
          .then((response) => {
            this.communities = response.data;
          })
          .catch(console.error);
      },

      editUser() {
        this.user = JSON.parse(localStorage.getItem("user"));
        this.isLoading = true;
        this.axios
          .post(`/api/v1/auth/editProfile/${this.$route.params.id}`, {
            firstname: this.auth_user.firstname,
            lastname: this.auth_user.lastname,
            email: this.auth_user.email,
            type: this.auth_user.type,
            state: "2679",
            localgovt: this.auth_user.localgovt,
            ward: this.auth_user.ward,
            dob: this.auth_user.dob,
            phc_general: this.auth_user.phc_general,
            gender: this.auth_user.gender,
            facility_code: this.auth_user.facility_code,
            institutional_id: this.auth_user.institutional_id,
            sector: this.auth_user.sector,
            user_image: this.auth_user.user_image,
            middlename: this.auth_user.middlename,
            nimc_number: this.auth_user.nimc_number,
            password: this.auth_user.password,
            phone_number: this.auth_user.phone_number,
            phc_type: this.auth_user.phc_type,
            agency_name: this.auth_user.agency_name,
            address1: this.auth_user.address1,
            community: this.auth_user.community,
          })
          .then((response) => {
            console.log(response);
            this.$breadstick.notify("Provider updated Successfully!", {
              position: "top-right",
            });
            this.isLoading = false;
          })
          .catch((error) => {
            console.log(error.response);
            this.$breadstick.notify("error on adding!", {
              position: "top-right",
            });
          });
      },
    },
    created() {
      this.fetchLga();
      this.getProviders();
    },
  };
</script>
